/* eslint-disable import/prefer-default-export */
/* eslint-disable import/prefer-default-export */
export const isArray = (elm) =>
  elm != null && // Verifica que elm no sea null o undefined
  (Object.prototype.toString.call(elm) === '[object Array]' || elm.constructor?.name === 'Array');

